import { CustomButton } from "../../../components/CustomButton";
import filterIcon from "../../../assets/icons/filter.svg";

export default function Header({ onFilterClick = () => {} }) {
  return (
    <div className="my-4">
      <div className="filter-btn-con">
        <CustomButton
          title={
            <div className="d-flex align-items-center">
              <img src={filterIcon} alt="filter" className="me-2" />
              Filter
            </div>
          }
          className="filter-btn"
          outline
          onClick={onFilterClick}
        />
      </div>
    </div>
  );
}
